// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xVv8h2d_TjpppDGFwggy {
  transition: transform 0.5s ease;
}

.pBvqshDHCHgHkeGxdOkA {
  transform: rotate(90deg);
}

.kpBVySTVR_sgYTy1kFDU {
  transform: rotate(270deg);
}

.wXnPEJ5i8mqQD8rCOdgv {
  transform: rotate(0);
}

.ZjgZUC90Tba2bFx_byXg {
  transform: rotate(180deg);
}
`, "",{"version":3,"sources":["webpack://./src/components/icons/Arrow/Arrow.module.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".root {\n  transition: transform 0.5s ease;\n}\n\n.down {\n  transform: rotate(90deg);\n}\n\n.up {\n  transform: rotate(270deg);\n}\n\n.right {\n  transform: rotate(0);\n}\n\n.left {\n  transform: rotate(180deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `xVv8h2d_TjpppDGFwggy`,
	"down": `pBvqshDHCHgHkeGxdOkA`,
	"up": `kpBVySTVR_sgYTy1kFDU`,
	"right": `wXnPEJ5i8mqQD8rCOdgv`,
	"left": `ZjgZUC90Tba2bFx_byXg`
};
export default ___CSS_LOADER_EXPORT___;
